// import * as process from 'process';

export * from './localStorageKeys';
export const ALLOW_TEST_MODE = process.env.REACT_APP_TEST_MODE ?? false;
// export const ALLOW_TEST_MODE = config.allowTestMode ?? false;
